if (!customElements.get('restock-notify')) {
  customElements.define(
    'restock-notify',
    class RestockNotify extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.toggle = this.querySelector('.restock-notify__toggle');
        this.panel = this.querySelector('.restock-notify__panel');
        this.fields = this.querySelector('[data-restock-fields]');
        this.success = this.querySelector('[data-restock-success]');
        this.error = this.querySelector('[data-restock-error]');
        this.sectionId = this.id.replace('Restock-', '');

        this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));
        // Shopify's spam check submits customer forms itself, so the sign-up is
        // left to it and the browser's own email validation guards the input.
        this.form.addEventListener('submit', () => this.remember());
        this.settle();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event.data));
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      setOpen(open) {
        this.panel.hidden = !open;
        this.toggle.setAttribute('aria-expanded', String(open));
        if (open) this.querySelector('input[type="email"]')?.focus();
      }

      get storageKey() {
        return `restock-notify:${this.dataset.product}`;
      }

      remember() {
        try {
          sessionStorage.setItem(
            this.storageKey,
            JSON.stringify({
              tags: this.querySelector('[data-restock-tags]')?.value,
              name: this.querySelector('[data-restock-name]')?.textContent,
            })
          );
        } catch (e) {}
      }

      // Shopify shares the posted state between every customer form on the
      // page, so a sign-up in the footer would otherwise land here too. Only a
      // sign-up made from this form leaves the note below, so without it the
      // element goes back to its resting state.
      settle() {
        const posted = this.hasAttribute('data-posted');
        const errored = this.hasAttribute('data-errored');
        if (!posted && !errored) return;

        let saved = null;
        try {
          saved = JSON.parse(sessionStorage.getItem(this.storageKey));
          if (posted) sessionStorage.removeItem(this.storageKey);
        } catch (e) {}

        if (!saved) {
          this.success.hidden = true;
          this.error.hidden = true;
          this.fields.hidden = false;
          this.setOpen(false);
          this.hidden = this.dataset.available === 'true';
          return;
        }

        // Shopify returns to the product without the chosen size, so the size
        // the visitor signed up for is put back into the copy and the tag.
        if (errored) {
          const tags = this.querySelector('[data-restock-tags]');
          const name = this.querySelector('[data-restock-name]');
          if (tags && saved.tags) tags.value = saved.tags;
          if (name && saved.name) name.textContent = saved.name;
          this.querySelector('input[type="email"]')?.focus();
        } else {
          this.success.focus();
        }
      }

      // Show only while the chosen size is sold out, and tag the sign-up with
      // that size so the newsletter can be sent to the right people.
      onVariantChange({ sectionId, html, variant }) {
        if (sectionId !== this.sectionId || !variant) return;
        const fresh = html.getElementById(this.id);
        const soldOut = fresh ? fresh.dataset.available !== 'true' : !variant.available;
        const signedUp = !this.success.hidden;
        this.dataset.available = String(!soldOut);
        this.hidden = !soldOut && !signedUp;
        if (!soldOut && !signedUp) this.setOpen(false);

        const tags = this.querySelector('[data-restock-tags]');
        const freshTags = fresh?.querySelector('[data-restock-tags]');
        if (tags && freshTags) tags.value = freshTags.value;
        const name = this.querySelector('[data-restock-name]');
        const freshName = fresh?.querySelector('[data-restock-name]');
        if (name && freshName) name.textContent = freshName.textContent;
      }
    }
  );
}
